module.exports = __webpack_public_path__ + "img/EMC_G_1.45f32061.png";